export const service_const = {
  basePath: process.env.BASE_PATH,
  tokenKey: process.env.TOKEN_KEY,
  appKey: process.env.APP_KEY,
  type: process.env.TYPE,
  version: process.env.VERSION,
  debug: process.env.NODE_ENV !== "production",
};



// WEBPACK FOOTER //
// ./src/assets/js/consts.js